var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2244_52318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C11.7575 0 7.685 1.68675 4.6875 4.68625C1.68693 7.68696 0.000858621 11.7565 0 16C0 20.2417 1.6875 24.3142 4.6875 27.3137C7.685 30.3132 11.7575 32 16 32C20.2425 32 24.315 30.3132 27.3125 27.3137C30.3125 24.3142 32 20.2417 32 16C32 11.7583 30.3125 7.68575 27.3125 4.68625C24.315 1.68675 20.2425 0 16 0Z",
    fill: "url(#paint0_linear_2244_52318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24311 15.8301C11.9081 13.7981 15.0181 12.4584 16.5731 11.8111C21.0181 9.96283 21.9406 9.64183 22.5431 9.63095C22.6756 9.62883 22.9706 9.66158 23.1631 9.8172C23.3231 9.94845 23.3681 10.126 23.3906 10.2506C23.4106 10.3751 23.4381 10.6588 23.4156 10.8803C23.1756 13.4103 22.1331 19.5498 21.6031 22.3836C21.3806 23.5826 20.9381 23.9846 20.5106 24.0238C19.5806 24.1093 18.8756 23.4098 17.9756 22.8201C16.5681 21.8968 15.7731 21.3223 14.4056 20.4216C12.8256 19.3806 13.8506 18.8083 14.7506 17.8733C14.9856 17.6286 19.0806 13.9048 19.1581 13.5671C19.1681 13.5248 19.1781 13.3673 19.0831 13.2843C18.9906 13.2011 18.8531 13.2296 18.7531 13.2521C18.6106 13.2841 16.3631 14.7711 12.0031 17.7128C11.3656 18.1513 10.7881 18.3651 10.2681 18.3538C9.69811 18.3416 8.59811 18.0308 7.78061 17.7653C6.78061 17.4396 5.98311 17.2673 6.05311 16.7141C6.08811 16.4261 6.48561 16.1313 7.24311 15.8301Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2244_52318",
    x1: 1600,
    y1: 0,
    x2: 1600,
    y2: 3200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2244_52318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.6c43bcd0175bc1ae16aa1f7ca49c5a3e.svg";
export { ForwardRef as ReactComponent };